/**
 * @Author: Zero
 * @Date: 2025-07-14 17:18:49
 * @Explain: 枚举
 */

// 满意度评价条件Tab
export enum ContentRatingTabEnum {
  /** 活动 */
  CAMPAIGN = 'campaign',
  /** 旅程节点 */
  JOURNEY = 'journey',
}

export enum SubscribeStatusEnum {
  /** 未订阅 */
  UNSUBSCRIBED = 0,
  /** 已订阅 */
  SUBSCRIBED = 1,
  /** 未知 */
  UNKNOWN = -1,
  /** 待处理 */
  PENDING = 3,
}

export enum segmentChannelEnum {
  EMAIL = 2000,
  WHATSAPP = 42,
}
